export default class Template6 {
  static getData() {
    return [];
  }
}
